import React from 'react';

const KairaliAIIcon = ({ size = 20, color = '#fff' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <line x1="12" y1="12" x2="12"   y2="4.5"   stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="12" y1="12" x2="18.5" y2="15.75"  stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="12" y1="12" x2="5.5"  y2="15.75"  stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="12" y1="12" x2="17.2" y2="9"    stroke={color} strokeWidth="1"   strokeLinecap="round" opacity="0.4"/>
    <line x1="12" y1="12" x2="12"   y2="18"   stroke={color} strokeWidth="1"   strokeLinecap="round" opacity="0.4"/>
    <line x1="12" y1="12" x2="6.8"  y2="9"    stroke={color} strokeWidth="1"   strokeLinecap="round" opacity="0.4"/>
    <circle cx="12"   cy="4.5"   r="2"   fill={color}/>
    <circle cx="18.5" cy="15.75" r="2"   fill={color}/>
    <circle cx="5.5"  cy="15.75" r="2"   fill={color}/>
    <circle cx="17.2" cy="9"   r="1.3" fill={color} opacity="0.55"/>
    <circle cx="12"   cy="18"  r="1.3" fill={color} opacity="0.55"/>
    <circle cx="6.8"  cy="9"   r="1.3" fill={color} opacity="0.55"/>
    <circle cx="12"   cy="12"  r="2.8" fill={color}/>
  </svg>
);

export default KairaliAIIcon;
